// ScanHistory.jsx
import React from "react";
import { Link } from "react-router-dom";
import BackArrow from "../assets/images/back-arrow.svg";
import ToothIcon from "../assets/images/tooth.svg";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { Eye, Calendar } from "lucide-react";

const scanData = [
  { date: "Jul 8", score: 0 },
  { date: "Jul 14", score: 65 },
  { date: "Jul 16", score: 0 },
  { date: "Jul 16", score: 0 },
  { date: "Jul 16", score: 0 },
  { date: "Jul 16", score: 0 },
];

const recentScans = [
  {
    date: "Jul 16, 2025",
    score: 0.0,
    label: "Oral Hygiene: 0.0 - Critical Risk",
    risk: "critical",
  },
  {
    date: "Jul 16, 2025",
    score: 0.0,
    label: "Oral Hygiene: 0.0 - Critical Risk",
    risk: "critical",
  },
  {
    date: "Jul 16, 2025",
    score: 0.0,
    label: "Oral Hygiene: 0.0 - Critical Risk",
    risk: "critical",
  },
  {
    date: "Jul 14, 2025",
    score: 65.0,
    label: "Oral Hygiene: 65.0 - Moderate Risk",
    risk: "moderate",
  },
  {
    date: "Jul 8, 2025",
    score: 0.0,
    label: "Oral Hygiene: 0.0 - Critical Risk",
    risk: "critical",
  },
];
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-gray-300 rounded-md shadow-md p-2 text-xs">
        <p className="font-semibold text-gray-800">Date: {label}</p>
        <p className="text-blue-600">Score: {payload[0].value}</p>
      </div>
    );
  }

  return null;
};
const DentalScanResult = () => {
  return (
    <div className="max-w-md mx-auto">
      {/* Header */}
      <div className="flex mb-5 px-6 relative z-50">
        <Link
          to={-1}
          className="w-9 h-9 bg-[#2D2D2D] rounded-full flex justify-center items-center"
        >
          <img src={BackArrow} alt="Back" />
        </Link>
        <div className="ml-4 -mt-1">
          <h1 className="text-lg font-semibold">
            Scan <span className="text-secondary">Result</span>
          </h1>
          <p className="text-xs text-white/85">
            Track your oral hygiene journey
          </p>
        </div>
      </div>
      {/* Background Blur */}
      <div className="circle-blur w-[75%] h-64 mx-auto mt-10 blur-[90px] absolute left-0 right-0 top-10"></div>
      {/* Chart Card */}
      <div className="px-6 w-full mb-8">
        <div className="bg-[#1D1D1D]/70 rounded-[20px] p-5 mb-4 relative z-20">
          <h3 className="text-base font-medium mb-3 flex items-center gap-2 text-white">
            Oral Hygiene Progress
          </h3>
          <div className="-ml-10">
            <ResponsiveContainer width={310} height={150}>
              <LineChart data={scanData}>
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <XAxis dataKey="date" fontSize={10} />
                <YAxis domain={[0, 100]} fontSize={10} />
                <Tooltip content={<CustomTooltip />} />
                <Line
                  type="monotone"
                  dataKey="score"
                  stroke="#2563eb"
                  strokeWidth={2}
                  dot={{
                    r: 4,
                    stroke: "#2563eb",
                    strokeWidth: 1,
                    fill: "#fff",
                  }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className="flex items-center">
            <p className="text-white text-xs">Total Scans</p>
            <p className="text-base font-bold text-secondary ml-2">
              {recentScans.length}
            </p>
          </div>
          <div className="flex items-center">
            <p className="text-white text-xs">
              Latest Overall Oral Hygiene Score
            </p>
            <p className="text-base font-bold text-red-600 ml-2">
              {recentScans[0]?.score}
            </p>
          </div>
        </div>
      </div>
      {/* Summary */}

      {/* Recent Scans */}
      <div className="bg-white px-6 pb-24 pt-6">
        <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
          <h3 className="text-base font-semibold text-primary mb-4">
            Recent Scans
          </h3>
        </AnimationOnScroll>
        <div className="space-y-3">
          {recentScans.map((scan, idx) => (
            <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
              <div
                key={idx}
                className="bg-[#fdfeff] border rounded-xl p-3 flex items-center justify-between border-[#dadeeb]"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center text-primary">
                    <img src={ToothIcon} className="w-4 h-4" alt="" />
                  </div>
                  <div>
                    <p className="text-xs text-primary flex items-center gap-1">
                      <Calendar size={14} /> {scan.date}
                    </p>
                    <p
                      className={`text-xxs font-medium mt-1 inline-block px-2 py-1 rounded-full ${
                        scan.risk === "critical"
                          ? "bg-red-50 text-red-800"
                          : "bg-[#fdf3d2] text-[#ba7304]"
                      }`}
                    >
                      {scan.label}
                    </p>
                  </div>
                </div>
                <Link
                  to="/dental-report"
                  className="text-xs px-2 py-1 font-medium bg-[#1970bd]/80 hover:bg-secondary hover:text-primary rounded-md text-white flex items-center gap-1"
                >
                  {/* <Eye size={14} /> */}
                  View
                </Link>
              </div>
            </AnimationOnScroll>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DentalScanResult;
